// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "article[data-v-1bbf00ab] {\n  margin: 0.5rem;\n}\narticle .fa-circle-notch[data-v-1bbf00ab] {\n  bottom: 0;\n  color: #bf2027;\n  font-size: 20rem;\n  left: calc(50% - 10rem);\n  margin: auto;\n  position: absolute;\n  top: 0;\n}", ""]);
// Exports
module.exports = exports;
